module.exports = __webpack_public_path__ + "img/290.f2ddce61.png";